import { TypeCompiler } from '@sinclair/typebox/compiler';

import { JobSchedule } from '../schema/job-schedule.schema';

export const JobScheduleValidator = TypeCompiler.Compile(JobSchedule);
